<template>
  <div class="web-box-all">
    <ext-header></ext-header>

    <div class="web-home-main">
      <div class="web-order-state">

        <h2 v-if="return_state=='1'" style="background:#409EFF;">
          订单编号：{{order_info.return_no}}
          <span v-if="return_state=='1'">待审核</span>
        </h2>

        <h2 v-if="return_state=='2'" style="background:#67C23A;">
          订单编号：{{order_info.return_no}}
          <span v-if="return_state=='2'" >已审核</span>
        </h2>

        <h2 v-if="return_state=='3'" style="background:#E6A23C;">
          订单编号：{{order_info.return_no}}
          <span v-if="return_state=='3'">已驳回</span>
        </h2>
        <h3 v-if="return_state=='3'" style="background:#E6A23C;">
          驳回原因：{{order_info.check_remark}}
        </h3>

        <h2 v-if="return_state=='4'" style="background:#409EFF;">
          订单编号：{{order_info.return_no}}
          <span v-if="return_state=='4'">已完成</span>
        </h2>

        <h3>退货帮助说明</h3>
        <p v-html="order_return_info"></p>
        <h3 v-if="return_state!='3'">退货地址信息：</h3>
        <ul v-if="return_state!='3'">
          <li>公司名称：{{order_return_user.return_company_name}}</li>
          <li>收件人：{{order_return_user.return_user_name}}</li>
          <li>联系电话：{{order_return_user.return_company_tel}}</li>
          <li>收货地址：{{order_return_user.return_company_address}}</li>
        </ul>

      </div>

      <div class="web-order-main">

        <div class="web-order-address">
            <h2>餐厅名称：{{store_info.store_name}}</h2>
            <ul>
                <li v-if="store_info.market_name">
                    <p>所属市场：{{store_info.market_name}}</p>
                </li>
                <li v-if="store_info.store_no">
                    <p>门店编号：{{store_info.store_no}}</p>
                </li>
                <li v-if="store_info.zoneNo">
                    <p>国际编码：{{store_info.zoneNo}}</p>
                </li>
                <li v-if="store_info.market_name">
                    <p>餐厅电话：{{store_info.store_phone}}</p>
                </li>
                <li v-if="store_info.user_phone">
                    <p>联系电话：{{store_info.user_phone}}</p>
                </li>
                <li v-if="store_info.store_address">
                    <p>餐厅地址：{{store_info.store_address}}</p>
                </li>
            </ul>
        </div>
        <div class="web-order-address-line"></div>

        <div class="web-order-info-title">
            <h2>选择退货原因</h2>
            <p>
              {{feedback_class}}
            </p>
        </div>

        <div class="web-order-info-title" v-if="order_info.return_remark">
            <h2>退货原因</h2>
            <p>{{order_info.return_remark}}</p>
        </div>

        <div class="web-order-info-title" v-if="return_state=='2'">
            <h2>退货快递编号 <i>*</i></h2>
            <p>
              <b-form-input v-model="logistics_no" placeholder="请输入退货快递编号"></b-form-input>
            </p>
        </div>

        <div class="web-order-info-image" v-if="image_list.length>0">
            <h2>凭证图片</h2>
            <ul>
              <li v-for="(vo,index) in image_list" :key="index">
                <img src="@/assets/goods_load.png" v-real-img="web_url+vo"/>
              </li>
            </ul>
        </div>

        <div class="web-order-info-title" style="border:0px;">
            <h2>退货商品</h2>
        </div>

        <div class="web-order-goods-box">

            <div v-for="(vo,index) in goods_list" :key="index" class="web-cart-list-data">
                <div class="web-cart-list-checkbox">
                  <img @click="get_goods_show(vo.goods_no)" src="@/assets/goods_load.png" v-real-img="web_url+vo.goods_image">
                </div>
                <div class="web-cart-list-goods">
                    <p>{{vo.goods_name}}</p>
                    <a>{{vo.goods_no}}</a>
                </div>
                <div class="web-cart-list-props"></div>
                <div class="web-cart-list-price">
                  <p>￥{{vo.price}} x {{vo.qty}}</p>
                </div>
            </div>

        </div>

      </div>

      <div class="web-order-footer">
        <ul>
            <li>
                <p>申请单：</p>
                <a>{{order_info.return_no}}</a>
            </li>
        </ul>
        <ul>
            <li>
                <p>退货单号：</p>
                <a>{{order_info.erp_return_no}}</a>
            </li>
        </ul>
        <ul>
            <li>
                <p>物流编号：</p>
                <a>{{order_info.logistics_no}}</a>
            </li>
        </ul>
        <ul>
            <li>
                <p>商品合计：</p>
                <a>￥{{order_info.goods_money}}</a>
            </li>
        </ul>
        <ul class="money">
            <li>
                <p>应退金额：</p>
                <a class="red">￥{{order_info.return_fee}}</a>
            </li>
        </ul>
        <h2 v-if="return_state=='2'">
          <a id="post_data" @click="post_data()" class="red">确定提交</a>
        </h2>
      </div>
    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

    <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl, upload} from '@/utils/extend'
import $ from 'jquery'
import Toast from '@/components/toast/index'

export default {
  name: 'sales_return',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-toast': Toast
  },
  data () {
    return {
      title: '订单详情',
      web_url: webUrl(),
      pay_win_state: 0,
      header_title: '',
      feedback_class: '',
      return_id: '',
      logistics_no: '',
      return_class: '',
      return_class_list: [],
      order_remark: '',
      order_return_info: '',
      return_remark: '',
      image_width: 0,
      sum_goods_money: '0.00',
      return_integral: '0.00',
      return_fee: 0,
      return_state: '3',
      up_return_state: true,
      store_info: {},
      order_info: {},
      goods_list: [],
      image_list: [],
      order_return_user: {},
      toast_state: 'display:none',
      toast_text: ''
    }
  },
  mounted () {
    var params = this.$route.query
    var orderNo = Decrypt(params.v)

    this.load_data(orderNo)
  },
  methods: {
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 3000)
    },
    load_user () {
      var that = this
      ajax({
        url: '/store/user/user_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.user_info = ret.data
        }
      })
    },
    load_data (orderNo) {
      var that = this

      ajax({
        url: '/store/user/user_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.store_info = ret.data
        }
      })

      ajax({
        url: '/store/order/order_return_show',
        method: 'post',
        data: {
          uid: getUserId(),
          id: orderNo
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.feedback_class = ret.data.order_info.select_return_remark
          that.order_info = ret.data.order_info
          that.return_state = ret.data.order_info.return_state
          that.return_id = ret.data.order_info.id
          that.header_title = ret.data.order_info.order_state_name
          that.image_list = ret.data.img_list
          that.goods_list = ret.data.goods_list

          if (ret.data.order_info.return_state === '1') {
            ajax({
              url: '/store/order/order_return_info',
              method: 'post',
              dataType: 'text',
              data: {
                uid: getUserId()
              }
            }, function (rrr) {
              that.order_return_info = rrr
            })
          } else if (ret.data.order_info.return_state === '3') {
            ajax({
              url: '/store/order/order_return_info',
              method: 'post',
              dataType: 'text',
              data: {
                uid: getUserId()
              }
            }, function (rrr) {
              that.order_return_info = rrr
            })
          } else {
            ajax({
              url: '/store/order/help_return_info',
              method: 'post',
              dataType: 'text',
              data: {
                uid: getUserId(),
                return_id: orderNo
              }
            }, function (rrr) {
              that.order_return_info = rrr
            })
          }
        }

        ajax({
          url: '/store/order/help_return_json',
          method: 'post',
          data: {
            uid: getUserId(),
            return_id: orderNo
          }
        }, function (rrr) {
          that.order_return_user = rrr.data
        })
      })
    },
    verify_post (type) {
      if (type === true) {
        $('#post_data').css({'background': '#cccccc'})
      } else {
        $('#post_data').css({'background': '#d81e06'})
      }
    },
    post_data () {
      var that = this
      var returnId = this.return_id
      var logisticsNo = this.logistics_no

      if (!logisticsNo || logisticsNo === '') {
        that.toast('请输入退货快递编号')
        return false
      } else {
        that.verify_post(true)

        if (that.up_return_state === true) {
          that.up_return_state = false
          ajax({
            url: '/store/order/ok_return_info',
            method: 'post',
            data: {
              uid: getUserId(),
              return_id: returnId,
              logistics_no: logisticsNo
            }
          }, function (ret) {
            if (ret && ret.code === 'success') {
              that.toast(ret.msg)
              setTimeout(function () {
                that.verify_post(false)
                that.up_return_state = true
                that.$router.push({path: '/order/return_order_list', query: {}})
              }, 2500)
            } else {
              that.verify_post(false)
              that.up_return_state = true
              that.toast(ret.msg)
            }
          })
        }
      }
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-state { width:100%; height:auto; margin-top:15px; flex-wrap:wrap; align-content:flex-start; border:1px solid #dfdfdf; }
    .web-order-state h2 { width:100%; height:50px; margin:0px;line-height:50px; font-size:14px; font-weight: bold; border-left:3px solid #d81e06; justify-content:space-between; padding:0px 20px;color:#ffffff;}
    .web-order-state h3 { width:100%; height:auto; margin:0px;line-height:30px; font-size:14px; font-weight: bold; justify-content:space-between; padding:0px 20px; color:#333333;}
    .web-order-state p { width:100%; height:auto; margin:0px 0px 15px 0px; flex-wrap:wrap; align-content:flex-start; font-weight: normal; padding:0px 20px; line-height:30px; font-size:14px; color:#333333; }
    .web-order-state ul { width:100%; height:auto; list-style: none;  display: flex; flex-flow:row; align-content:flex-start; flex-wrap:wrap;}
    .web-order-state ul li { width:50%; height:40px; line-height:40px; font-size:14px; color:#333333;}

.web-order-main { width:100%; height:auto; padding:20px; margin-top:15px; border:1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start;}
    .web-order-address { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
    .web-order-address h2 { width:100%; height:30px; line-height:30px; font-size:14px; font-weight: bold; margin:0px; padding:0px; color:#333333;}
    .web-order-address ul { width:100%; height:auto; list-style:none; margin:0px; padding:0px; display: flex; flex-flow:row; align-content:flex-start; flex-wrap:wrap;}
    .web-order-address ul li { width:50%; height:30px; margin:0px; padding:0px;}
    .web-order-address ul li p { width:100%; height:30px; margin:0px; padding:0px; line-height:30px; font-size:14px; color:#333333;}
    .web-order-address-line { width:100%; height:5px; margin-top:15px; background-size: auto 100%; background-image:url('../../assets/icon/order_address_line.png'); background-repeat : repeat-x;}

.web-order-info-title { width:100%; height:auto; margin-top:10px; border-bottom: 1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start;}
    .web-order-info-title h2 { width:100%; height:30px; line-height:30px; font-size:14px; font-weight: bold; margin:0px; padding:0px; color:#333333;}
    .web-order-info-title h2 i { color:#d81e06;}
    .web-order-info-title p { width:100%; height:30px; line-height:30px; font-size:14px; }
    .web-order-info-title p div.custom-radio { cursor: pointer;}
    .web-order-info-title h2 span { font-size:14px; color:#666666; font-weight: normal; margin-left:20px;}
    .web-order-info-title textarea { margin-bottom: 15px;}
    .web-order-info-title p input { font-size:14px;}
  .web-cart-list-checkbox label { width:auto; height:auto; cursor: pointer; position: relative; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-checkbox { width:140px; height:auto;  -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; line-height:40px; font-size:14px; color:#333333;}

  .web-cart-list-checkbox-input { width:20px; height:100%; line-height:40px; position: relative; margin:0px 10px 0px 10px; font-size:14px; color:#333333;}
  .web-cart-list-checkbox-input input { width:18px; height:18px; position: absolute; top:50%; left:1px; margin-top:-9px; padding:0px; font-size:14px; color:#333333;}

.web-order-info-image { width:100%; height:auto; margin-top:10px; overflow: hidden; border-bottom: 1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start;}
    .web-order-info-image h2 { width:100%; height:30px; line-height:30px; font-size:14px; font-weight: bold; margin:0px; padding:0px; color:#333333;}
    .web-order-info-image p { width:100%; height:30px; line-height:30px; font-size:14px; }
    .web-order-info-image p div.custom-radio { cursor: pointer;}
    .web-order-info-image h2 span { font-size:14px; color:#666666; font-weight: normal; margin-left:20px;}
    .web-order-info-image ul { width:100%; height:140px; margin:0px; padding:0px; list-style: none; flex-flow:row; align-content:flex-start;}
    .web-order-info-image ul li { width:120px; height:120px; overflow: hidden; position:relative; border:1px solid #dfdfdf; overflow: hidden; margin:5px; cursor: pointer;}
    .web-order-info-image ul li img { width:120px; height:120px; object-fit: cover;}
    .web-order-info-image ul li a { width:120px; height:120px; padding:45px 0px; display: none; justify-content:center; position: absolute; left:0px; top:0px; background: rgba(0,0,0,0.5);}
    .web-order-info-image ul li a img { width:30px; height:30px; margin:0px 45px;}
    .web-order-info-image ul li:hover { display: block;}
    .web-order-info-image ul li:hover a { display: block;}

    .web-order-info-integral { width:100%; height: 50px; margin-top:10px;}
        .web-order-info-integral-input { width:200px; height: 30px; border:1px solid #dfdfdf;}
            .web-order-info-integral-input input { width:190px; height:20px; border:0px; margin-top:5px; line-height:20px; font-size:14px; padding:0px 15px;}
        .web-order-info-integral-button { width:100px; height:30px; border:1px solid #d81e06; margin-left:10px;}
            .web-order-info-integral-button p { width:100px; cursor: pointer; height:30px;  text-align: center; line-height: 30px; justify-content:center; font-size:14px; color:#d81e06;}
  .web-cart-list-data { width:100%; height:auto; margin-top:0px; border-left:1px solid #dfdfdf; border-bottom:1px solid #dfdfdf; border-right:1px solid #dfdfdf;}
 .web-cart-list-goods { width:210px; height:auto; line-height:40px; font-size:14px; flex-wrap:wrap; align-content:flex-start; color:#333333;}
  .web-cart-list-goods p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-goods a { width:100%; height:auto; line-height:20px; font-size:14px; color:#aaaaaa;}
  .web-cart-list-goods a:hover { color:#aaaaaa;}
  .web-cart-list-props {width:140px; height:auto; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-props p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-price {width:120px; height:auto; line-height:80px; font-size:14px; color:#333333;}
  .web-cart-list-price p { width:100%; height:auto; line-height:80px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-quantity { width:170px; height:auto; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; text-align: center;justify-content:center; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-quantity p { width:136px; height:40px; line-height:40px; overflow: hidden; flex-flow:row; justify-content:flex-start; margin-top:35px; border:1px solid #dfdfdf;}
  .web-cart-list-quantity p a { width: 40px; height: 40px; cursor: pointer; background: #efefef; font-size:28px; color:#333333; line-height:34px; text-align: center; justify-content:center;}
  .web-cart-list-quantity p input { width: 55px; height:38px; line-height:38px; text-align: center; font-size:14px; color:#333333; border:0px; min-height: 20px;}
  .web-cart-list-sum { width:120px; height:auto; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-sum p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-action { width:100px; height:auto; line-height:40px; text-align: center; justify-content:center; font-size:14px; color:#333333;}
  .web-cart-list-action a { width:100%; height:auto; cursor: pointer; text-align: center; justify-content:center; line-height:20px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-checkbox img { width:80px; height:80px; cursor: pointer; margin:15px 0px 15px 15px;}

  .web-order-goods-box { width:100%; height:auto; margin-top:10px; border-top:1px solid #dfdfef; flex-wrap:wrap; align-content:flex-start;}

.web-order-footer { width:100%; height:auto; flex-wrap:wrap; margin-top:15px;  align-content:flex-start;}
    .web-order-footer ul { width:100%; height:auto; margin:0px; padding:0px 15px; flex-wrap:wrap; align-content:flex-start;}
    .web-order-footer ul.money {  height:90px; background: #f4f4f4; padding-top:15px; border-top:1px solid #dfdfdf;}
    .web-order-footer ul li { width:100%; height:30px;margin:0px; padding:0px; justify-content:flex-end;}
    .web-order-footer ul li p { width:70px; height:30px;margin:0px; padding:0px; line-height:30px; color:#333333; font-size:14px;}
    .web-order-footer ul li a { min-width:120px; height:30px; line-height:30px; color:#333333; font-size:14px; text-align: right; justify-content:flex-end;}
    .web-order-footer ul li a:hover { color:#333333;}
    .web-order-footer ul li a span { color:#999999; margin-left:5px;}
    .web-order-footer ul li a span.select { color:#E6A23C;}
    .web-order-footer ul li a.red { color:#d81e06; font-size:18px; font-weight: bold;}
    .web-order-footer h2 { width:100%; height:50px; margin-top:15px; justify-content:flex-end;}
    .web-order-footer h2 a {width:150px; height:40px; margin-left:15px; cursor: pointer;border: 1px solid #dfdfdf; line-height:38px; border-radius: 4px; text-align: center; justify-content:center; background: #ffffff; font-size:14px; color:#333333;}
    .web-order-footer h2 a:hover { color:#333333;}
    .web-order-footer h2 a.red { color:#ffffff; background: #d81e06;border: 1px solid #d81e06;}
    .web-order-footer h2 a.red:hover { color:#ffffff;}

#textarea { font-size:14px;}

</style>



// WEBPACK FOOTER //
// src/pages/order/return_order_show.vue